<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text text-uppercase">Presumptive Referral Form</div>
      </v-card-title>
      <v-card-text>
        <!--PRESUMPTIVE PATIENT INFO SECTION -->

        <div>
         
          <v-row>
            <v-col lg="4">
              <label>Name</label>
              <v-text-field v-model.trim="presumptiveDataEach.name" type="text" outlined dense></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Age</label>
               <v-text-field v-model.trim="presumptiveDataEach.age" type="text" outlined dense></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Sex</label>
              <v-radio-group v-model="presumptiveDataEach.sex" row>
                <v-radio label="Male" value="1"></v-radio>
                <v-radio label="Female" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col lg="3">
              <label>Case Found At</label>
              <v-select
                v-model="presumptiveDataEach.case_found_at"
                :items="caseFoundatOpt"
                item-text="name"
                item-value="id"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="3" v-if="presumptiveDataEach.case_found_at == 5">
              <label>Previous ID</label>
              <v-text-field v-model="presumptiveDataEach.previousID" outlined dense type="number"></v-text-field>
            </v-col>

            <template
              v-if="presumptiveDataEach.case_found_at == 2 || presumptiveDataEach.case_found_at == 3"
            >
              <v-col lg="2">
                <label>Index Case Code</label>
                <v-text-field
                  v-model="presumptiveDataEach.index_case_no"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </v-col>

              <v-col lg="2">
                <label>Index Case Year</label>
                <v-text-field
                  v-model="presumptiveDataEach.index_case_year"
                  outlined
                  dense
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col lg="2">
                <label>Index Case Initial</label>
                <v-select
                  v-model="presumptiveDataEach.index_case_initial"
                  :items="InitialOpt"
                  item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col lg="3">
                <label>Relationship</label>
                <v-select
                  v-model="presumptiveDataEach.relationship"
                  :items="relationOpt"
                   item-text="text"
                  item-value="id"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </template>
          </v-row>
        </div>
        <v-row>
          <v-col lg="4">
            <label>Referral Date</label>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="presumptiveDataEach.referral_date"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="presumptiveDataEach.referral_date"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col lg="4">
            <label>Volunteer</label>
            <v-select
              v-model="presumptiveDataEach.volunteer_id"
              :items="volunteers"
              item-value="id"
              dense
              outlined
            >
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                {{ data.item.code }} ({{ data.item.name }})
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ data.item.code }} ({{ data.item.name }})
              </template>
            </v-select>
          </v-col>
        </v-row>
        <!-- PATIENT INFO SECTION -->
      </v-card-text>
    </v-card>

    <v-card class="card--shadow">
      <v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="emitPresumptiveData" class="form-btn">
            <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  props: {
    presumptiveDataEach: {
      type: Object,
      default: () => {
        return {
          name: null,
          sex: null,
          age: null,
          case_found_at: null,
          index_case_no: null,
          index_case_year: null,
          index_case_initial: null,
          relationship: null,
          previousID: null,
          volunteer_id: null,
          referral_date: null,
          existing_presumptive:0,
          existing_presumptive_id:"",
        };
      }
    }
  },
  data: () => ({
    menu: false,
    menu1: false,
    menu2: false,
    menuDob: false,
  }),

  computed: {
    ...mapState("BasicData", [
      "commonOpt",
      "commonResultOpt",
      "InitialOpt",
      "relationOpt"
    ]),
    ...mapState("Volunteer", ["volunteers"]),
    ...mapState("Presumptive", ["presumptiveData"]),
    ...mapGetters("BasicData", ["caseFoundatOpt"])
  },
  methods: {
    emitPresumptiveData() {
      this.$emit("emitForm", this.presumptiveDataEach);
      // this.presumptiveDataEach.name = null;
      // this.presumptiveDataEach.sex = null;
      // this.presumptiveDataEach.age = null;
      // this.presumptiveDataEach.case_found_at = null;
      // this.presumptiveDataEach.index_case_no = null;
      // this.presumptiveDataEach.index_case_year = null;
      // this.presumptiveDataEach.index_case_initial = null;
      // this.presumptiveDataEach.relationship = null;
      // this.presumptiveDataEach.previousID = null;
      // this.presumptiveDataEach.volunteer_id = null;
      // this.presumptiveDataEach.referral_date = null;
    }
  },
  created() {
    this.$store.dispatch("BasicData/getBasicData");
    this.$store.dispatch("Presumptive/getPresumptiveData",{
      township_id: this.$route.params.township_id
    });
    this.$store.dispatch(
      "Volunteer/getVolunteerByTwnId",
      this.$route.params.township_id
    );
  }
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
h3,
p {
  margin: 0px;
}
.patient-detail h3,
p {
  font-size: 16px;
}
h3 {
  color: #453f3f;
  letter-spacing: 1px;
  font-weight: 400;
}
.header {
  background-color: #e6e6e6;
  border-radius: 5px;
}
</style>
